import { ReactElement, useState } from "react";
import { useLocation } from "react-router-dom";

interface SubItem {
  title: string;
  url: string;
}

interface SidebarRowProps {
  title: string;
  icon?: ReactElement;
  url?: string;
  children?: SubItem[];
  onClick?: () => void;
}

const SidebarRow = ({
  title,
  url,
  children,
  onClick,
  icon,
}: SidebarRowProps) => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const isActive = url ? pathname === url || pathname.startsWith(url) : false;

  if (children) {
    return (
      <>
        <span
          className={`sideBarTitle ${isActive ? "activeTitle" : ""}`}
          onClick={() => setOpen(!open)}
          style={{ cursor: "pointer" }}
        >
          {title}
        </span>
        {open &&
          children.map((sub) => (
            <a key={sub.url} href={sub.url} onClick={onClick}>
              <span className="sideBarTitle1">{sub.title}</span>
            </a>
          ))}
      </>
    );
  }

  return (
    <a href={url} className="sidebarLink" onClick={onClick}>
      <span className="sidebarLinkIcon">{icon && icon}</span>
      <p className={`sideBarTitle ${isActive ? "activeTitle" : ""}`}>{title}</p>
    </a>
  );
};

export default SidebarRow;
